// map + flatten helper
// extractor: (item) => item[key] or any array
export const flatMapBy = <T, U>(
  array: T[] = [],
  extractor: (item: T) => U[] | null | undefined,
): U[] => array.flatMap((item) => extractor(item) ?? []);

// normalizes a multiselect onChange value (single value, array, or empty) into an array
export const normalizeToArray = <T>(value: T | T[] | null | undefined): T[] => {
  if (Array.isArray(value)) return value;
  return value !== undefined && value !== null ? [value] : [];
};

// intersects selectedValues with the known option values, in option order
export const getSafeSelectedValues = <T>(options: { value: T }[], selectedValues: T[]): T[] =>
  options.filter((option) => selectedValues.includes(option.value)).map((option) => option.value);
